"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _storage = require("@/utils/storage");
var _default = exports.default = {
  state: function state() {
    return {
      language: (0, _storage.getItem)("language") || "en"
    };
  },
  mutations: {
    /**
     * 设置国际化
     */
    setLanguage: function setLanguage(state, lang) {
      (0, _storage.setItem)("language", lang);
      state.language = lang;
    }
  },
  actions: {}
};